// extracted by mini-css-extract-plugin
export default {"link":"SidebarLink_link__vAcKk"};